import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { configurationSettings, LoyaltyMemberIdentifier } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { InputType } from '../../../subcomponents';
import { AutoCompleteType } from '../../../subcomponents/form/auto-complete-type';
import { CaptchaField } from '../../../subcomponents/form/field/captcha/captcha-field';
import { InputField } from '../../../subcomponents/form/field/input/input-field';
import { getFieldClassName, getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { MemberPasswordResetCreateFormContextInstance } from '../password-reset-create-form/types/context';
import { MemberPasswordResetCreateFormFieldName } from './types/name';
import { defaultMemberPasswordResetCreateFormFieldPropsProvider, memberPasswordResetCreateFormFieldPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-password-reset-create-form-field');
const MemberPasswordResetCreateFormField = observer(props => {
    const { onChange, validationConfig, validator, formData, validationResult, disabled } = useContext(MemberPasswordResetCreateFormContextInstance);
    const { memberIdentifier } = configurationSettings.data.loyalty.authentication;
    const getCommonFieldProps = (key) => ({
        id: getFieldId(b, key),
        name: key,
        className: getFieldClassName(b, key),
        error: validationResult.validationErrors[key],
        disabled
    });
    switch (props.name) {
        case MemberPasswordResetCreateFormFieldName.Identifier: {
            if (memberIdentifier === LoyaltyMemberIdentifier.Email) {
                const key = 'email';
                return (_jsx(InputField, Object.assign({}, getCommonFieldProps(key), { type: InputType.Email, displayText: props.displayText, value: formData[key], validationConfig: validationConfig[key], autoCompleteType: AutoCompleteType.Email, validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
            }
            const key = 'username';
            return (_jsx(InputField, Object.assign({}, getCommonFieldProps(key), { displayText: props.displayText, value: formData[key], autoCompleteType: AutoCompleteType.Username, validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
        }
        case MemberPasswordResetCreateFormFieldName.Captcha: {
            const key = 'captcha';
            return (_jsx(CaptchaField, Object.assign({}, getCommonFieldProps(key), { displayText: props.displayText, validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue) })));
        }
        default:
            throw new InvalidFieldNameError('MemberPasswordResetCreateFormField', props.name);
    }
});
MemberPasswordResetCreateFormField.displayName = 'MemberPasswordResetCreateFormField';
/**
 * The **Member Password Reset Create Form Field** component allows a customer to reset their loyalty account password using either their **email**
 * or **username**.
 */
export const MemberPasswordResetCreateFormFieldComponent = withComponentWrapper(MemberPasswordResetCreateFormField, defaultMemberPasswordResetCreateFormFieldPropsProvider, memberPasswordResetCreateFormFieldPropsValidator);
//# sourceMappingURL=member-password-reset-create-form-field.js.map